/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { ColorWallMetadata }
from '@thd-olt-component-react/metadata';

import { ColorWall }
from '@thd-olt-component-react/color-wall';

export { ColorWallMetadata };

export { ColorWall };

const SlotA1 = withLayout(
  [

    ColorWallMetadata,

  ],

);

const SlotA2 = withLayout(
  [

    ColorWall,

  ],

);

const ssr = typeof window === 'undefined';

export {

  SlotA1,

  SlotA2,

};